export const FINISHED_SIGNUP_AT_KEY = 'finished_signup_at';
